import React from 'react'
import {extractedHour, renderIconSource, renderStatut} from '../../../../components/renders'
import TempsEcoule from './TempsEcoule'

const DemandeInfos = (props) => {
  const {demandeId, demandeClient, fromModal} = props
  const iconSource = demandeClient?.demandeSource?.id

  const renderTempsEcoule = () => {
    const estAvantTraitement = !demandeClient?.dateProposition
    const estTraitee = !!demandeClient?.delaiTraitementReel
    return (
      <TempsEcoule
        date={!estTraitee
          ? (estAvantTraitement ? demandeClient?.dateCreation : (demandeClient?.delaiIntermediaire ?? demandeClient?.dateProposition))
          : demandeClient?.dateCreation}
        dateMax={estAvantTraitement ? demandeClient?.delaiAvantTraitement : demandeClient?.delaiTraitement}
        dateReel={!estTraitee
          ? (estAvantTraitement ? demandeClient?.delaiAvantTraitementReel : demandeClient?.delaiTraitementReel)
          : demandeClient?.delaiTraitementReel}
        heureOuverture={extractedHour(demandeClient?.equipe?.heureDebut)}
        heureFermeture={extractedHour(demandeClient?.equipe?.heureFin)}
        heurePauseDebut={extractedHour(demandeClient?.equipe?.heureDebutPause)}
        heurePauseFin={extractedHour(demandeClient?.equipe?.heureFinPause)}
        joursSpecifiques={demandeClient?.equipe?.specificDay}
      />
    )
  }

  return (
    <div className='d-flex justify-content-between align-items-center'>
      <div className='d-flex align-items-center gap-1 flex-column'>
        {fromModal ? (
          <>
            <div className={'d-flex w-100 align-items-center justify-content-between'}>
              <span className='fs-5 text-gray-700'>
                Demande<span className='text-primary fs-3 ms-1'> #{demandeId}</span>
              </span>
              <div className=''>{renderIconSource(iconSource, true, false, true)}</div>
            </div>
            <div className={'d-flex align-items-center gap-2'}>
              <span className={'text-gray-600'}>Temps écoulé:</span>
              <div>{renderTempsEcoule()}</div>
            </div>
          </>
        ) : (
          <div className='d-flex flex-column gap-3'>
            <div className='d-flex gap-10 align-items-center'>
              <span className='fs-3'>
                Demande<span className='text-primary fs-3'> #{demandeId}</span>
              </span>
              <div className=''>{renderIconSource(iconSource, true, false, true)}</div>
              <span>{renderStatut(demandeClient?.clientDemandeEtape, demandeClient?.intervention)}</span>
            </div>
            <div className='d-flex gap-6'>
              <div>
                <div className='text-gray-600 mr-3 mb-2'>Temps écoulé:</div>
              </div>
              <div>
                <div className='mb-2'>{renderTempsEcoule()}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default DemandeInfos